var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('h4',{staticClass:"title-card-Status"},[_vm._v("Historic Status")]),_c('div',{attrs:{"id":"chart"}},[_c('vue-apex-charts',{attrs:{"type":"rangeBar","height":"135","options":_vm.chartOptions,"series":_vm.series}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }